export default __webpack_public_path__ + "static/media/earring.4f4dfcc3.webp";